import React from 'react'
import { TextContainer, Image, DisplayText, Markdown } from '../components'
import styles from 'assets/scss/views/Auth.scss'
import defaultPropertyImage from './../assets/images/defaultPropertyImage.png'
import * as translationService from '../services/translationService'

export default () => (
  <div className={styles.Auth}>
    <div className={styles.Text}>
      <TextContainer>
        <DisplayText>{translationService.t('tenant_profile.property_not_found.title')}</DisplayText>
        <Markdown source={translationService.t('tenant_profile.property_not_found.info')} />
      </TextContainer>
    </div>
    <div className={styles.Image}>
      <Image source={defaultPropertyImage} />
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/views/PropertyNotFoundView.js